import { format, isToday } from "date-fns";
const LargeMonthViewNumbers = ({day, goToDayView}) => {
  const [year, month, date] = day.split('-').map(Number);
  const newDate = new Date(year, month - 1, date);

    return(
        <time onClick={() => goToDayView(newDate)} id="date-number" dateTime={newDate} className={`calendar__month-date-number${isToday(newDate) ? ' is-today' : ''}`}>
          {format(newDate, 'd')}
        </time>
    )
}
export default LargeMonthViewNumbers;
